/* =====================================================================
   NYRI — DOBÍRKA + UPSELL + PŘIDÁNÍ DO KOŠÍKU (assets/nyri-dobirka.js)
   Kód je 1:1 přesunutý z patičky (dřív blok rFXbJH „DOBÍRKA kód Liquidu").
   Žádný řádek logiky se nezměnil — jen se teď stáhne jednou a prohlížeč
   si ho pamatuje, místo aby byl vložený do každé stránky.
   ===================================================================== */
(function(){
'use strict';
if(window.__NYRI_CART__){ return; }
window.__NYRI_CART__ = true;


var FEE_VARIANT = 55088732242249;
var FEE_HANDLE  = 'poplatek-za-dobirku';
var FEE_CENTS   = 4900;

var MAG    = {handle:'magnesium-bisglycinate-b6',         variant:54605959823689};
var IMU    = {handle:'imunity-complex-vitamin-c-acerola', variant:55546937573705};
var BEAUTY = {handle:'beauty-gummies-vlasy-plet-nehty',   variant:54245422268745};
var ASHWA  = {handle:'ashwagandha-gummies-adaptogen',     variant:54605834518857};
var DEFAULT_PAIR = [MAG, IMU];
var OVERRIDE = {
  'magnesium-bisglycinate-b6':         [BEAUTY, ASHWA],
  'imunity-complex-vitamin-c-acerola': [BEAUTY, ASHWA]
};

var T = {
  offHeading:'Chceš platit dobírkou?',
  offText:'Posíláme na dobírku. Musíš si ji ale zvolit tady v košíku — v pokladně už ji nenajdeš.',
  offButton:'Přidat dobírku',
  feeLabel:'+49 Kč',
  onHeading:'Platíš dobírkou',
       onText:'Poplatek 49 Kč je připočtený k objednávce. Celou částku zaplatíš při převzetí zásilky.',
  onCancel:'Zrušit dobírku',
  subHeading:'Tady dobírka nejde',
  subText:'Máš v košíku předplatné. To se platí kartou, aby se ti další balení mohlo strhávat automaticky. Dobírku můžeš využít u jednorázových nákupů.',
  codErr:'Nepovedlo se to změnit. Zkus to prosím znovu.',
  upHeading:'Přidej do své rutiny',
  upAdding:'Přidávám…',
  upErr:'Nepovedlo se přidat do košíku. Zkus to prosím znovu.'
};


var DBG = /[?&]nyridebug=1/.test(window.location.search);
var dbgBox = null;
function dbgInit(){
  if(!DBG || dbgBox || !document.body){ return; }
  dbgBox=document.createElement('div');
  dbgBox.style.cssText='position:fixed;right:8px;bottom:8px;z-index:99999;max-width:340px;'
    +'max-height:45vh;overflow:auto;background:rgba(0,0,0,.86);color:#9EFF9E;font:11px/1.45 monospace;'
    +'padding:8px 10px;border-radius:8px;white-space:pre-wrap;pointer-events:none';
  document.body.appendChild(dbgBox);
}
function log(){
  var msg=[].slice.call(arguments).map(function(a){
    return (typeof a==='object') ? JSON.stringify(a) : String(a);
  }).join(' ');
  if(window.console){ console.log('[NYRI]', msg); }
  if(DBG){
    dbgInit();
    if(dbgBox){
      dbgBox.textContent += msg + '\n';
      dbgBox.scrollTop = dbgBox.scrollHeight;
    }
  }
}
function root(){ return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; }
function cartUrl(){ return (window.routes&&window.routes.cart_url) || (root()+'cart'); }


var css = ''
+ '.nyri-cod{border:1.5px solid #E7D4DC;background:#F4E4ED;border-radius:18px;padding:20px 20px 18px;'
+   'margin:20px 0 18px;text-align:left;transition:background .25s,border-color .25s,box-shadow .25s}'
+ '.nyri-cod.is-on{background:#fff;border-color:#5C1F2E;box-shadow:0 0 0 1px #5C1F2E inset}'
+ '.nyri-cod.is-info{background:#FAF6F7;border-color:#E7D4DC;box-shadow:none}'
+ '.nyri-cod.is-busy{opacity:.55;pointer-events:none}'
+ '.nyri-cod__h{font-family:"Fraunces",Georgia,serif;font-style:italic;font-weight:700;font-size:21px;'
+   'line-height:1.25;color:#5C1F2E;margin:0 0 10px;display:flex;align-items:center;gap:10px}'
+ '.nyri-cod__tick{flex:0 0 auto;width:24px;height:24px;border-radius:50%;background:#5C1F2E;color:#fff;'
+   'font-family:Arial,sans-serif;font-style:normal;font-size:14px;font-weight:700;display:flex;'
+   'align-items:center;justify-content:center;line-height:1}'
+ '.nyri-cod__p{font-family:"Manrope",Arial,sans-serif;font-size:13.5px;line-height:1.6;color:#5A5C61;margin:0 0 16px}'
+ '.nyri-cod.is-info .nyri-cod__p{margin-bottom:0}'
+ '.nyri-cod__btn{width:100%;border:none;border-radius:999px;background:#B02F50;color:#fff;'
+   'font-family:"Manrope",Arial,sans-serif;font-size:13px;font-weight:800;letter-spacing:.09em;'
+   'text-transform:uppercase;padding:16px 18px;cursor:pointer;display:flex;align-items:center;'
+   'justify-content:center;gap:12px;transition:background .18s,transform .12s}'
+ '.nyri-cod__btn:hover{background:#8F1922}'
+ '.nyri-cod__btn:active{transform:scale(.985)}'
+ '.nyri-cod__tag{background:rgba(255,255,255,.24);border-radius:999px;padding:4px 11px;font-size:12.5px;letter-spacing:.04em}'
+ '.nyri-cod__cancel{background:none;border:none;padding:0;font-family:"Manrope",Arial,sans-serif;'
+   'font-size:12.5px;color:#B07080;text-decoration:underline;cursor:pointer}'
+ '.nyri-cod__err{font-family:"Manrope",Arial,sans-serif;font-size:12.5px;color:#8F1922;margin:10px 0 0;display:none}'
+ '.nyri-cod.has-err .nyri-cod__err{display:block}'
+ '.nyri-cod__pulse{animation:nyriPulse .7s ease}'
+ '@keyframes nyriPulse{0%{color:#2E3136}30%{color:#B02F50}100%{color:#2E3136}}'
+ '.cart-item.nyri-fee-row quantity-popover{visibility:hidden;pointer-events:none}'
+ 'body.nyri-cod-on .cart__dynamic-checkout-buttons,'
+ 'body.nyri-cod-on .additional-checkout-buttons{display:none !important}'
+ '.nyri-up-wrap{margin:18px 0 14px}'
+ '.nyri-up__h{font-size:1.1rem;font-weight:700;letter-spacing:.11em;text-transform:uppercase;color:#2E3136;margin:0 0 8px}'
+ '.nyri-up{border:1px solid rgba(0,0,0,.12);border-radius:16px;padding:6px 14px}'
+ '.nyri-up__i{display:flex;align-items:center;gap:12px;padding:10px 0;cursor:pointer}'
+ '.nyri-up__i+.nyri-up__i{border-top:1px solid rgba(0,0,0,.07)}'
+ '.nyri-up__box{flex:0 0 auto;width:22px;height:22px;border:1.5px solid rgba(0,0,0,.25);border-radius:6px;'
+   'display:flex;align-items:center;justify-content:center;color:transparent;font-size:13px;transition:.15s}'
+ '.nyri-up__i.on .nyri-up__box{background:#5C1F2E;border-color:#5C1F2E;color:#fff}'
+ '.nyri-up__img{flex:0 0 auto;width:46px;height:46px;border-radius:10px;object-fit:cover;background:#F4E4ED}'
+ '.nyri-up__t{flex:1 1 auto;font-size:1.3rem;line-height:1.3;color:#2E3136}'
+ '.nyri-up__p{flex:0 0 auto;font-size:1.3rem;font-weight:700;color:#5C1F2E}'
+ '.nyri-up-err{color:#8F1922;font-size:12.5px;margin:8px 0 0;font-family:"Manrope",Arial,sans-serif}';
var styleEl=document.createElement('style'); styleEl.textContent=css;
document.head.appendChild(styleEl);


var cart=null, busy=false, selfMutating=false, autoFixing=false;

function getCart(){
  return fetch(root()+'cart.js?_='+Date.now(),{headers:{'Accept':'application/json'},cache:'no-store'})
    .then(function(r){ return r.json(); });
}
function feeQty(){ var q=0; if(cart){ (cart.items||[]).forEach(function(i){ if(i.variant_id===FEE_VARIANT){ q+=i.quantity; } }); } return q; }
function realCount(){ return cart ? (cart.item_count - feeQty()) : 0; }
function hasSub(){
  if(!cart){ return false; }
  var found=false;
  (cart.items||[]).forEach(function(i){
    if(i.selling_plan_allocation || i.selling_plan_allocation_id){ found=true; }
  });
  return found;
}


function isForeign(node){
  if(!node){ return false; }
  var el=(node.nodeType===1)?node:node.parentElement;
  if(!el||!el.closest){ return false; }
  return !!el.closest('[class*="globe"], [id*="globe"], [class*="delivery"], [data-nyri-cod]');
}
function paintTotals(){
  if(!cart){ return; }
  document.querySelectorAll('.totals__total-value').forEach(function(el){
    el.textContent = money(cart.total_price);
  });
  var dst=document.querySelector('#main-cart-footer');
  if(dst){ dst.classList.toggle('is-empty', !cart || cart.item_count===0); }
}


function fetchSection(id){
  return fetch(cartUrl()+'?section_id='+id+'&_='+Date.now(),{cache:'no-store'})
    .then(function(r){
      if(!r.ok){ throw new Error(id+' HTTP '+r.status); }
      return r.text();
    })
    .then(function(t){ return new DOMParser().parseFromString(t,'text/html'); });
}
function zastarale(od){
  var K=window.NyriKosik;
  return !!(K && K.zmeneno && K.zmeneno > od);
}
function redrawDrawer(pokus){
  var live=document.querySelector('#CartDrawer');
  if(!live){ log('drawer tu není, přeskakuju'); return Promise.resolve(false); }
  var od=Date.now();
  return fetchSection('cart-drawer').then(function(doc){
    if(zastarale(od) && (pokus||0)<2){ log('drawer je stary, beru cerstvy'); return redrawDrawer((pokus||0)+1); }
    var src=doc.querySelector('#CartDrawer');
    if(!src){ throw new Error('v odpovedi neni #CartDrawer'); }
    selfMutating=true;
    live.innerHTML=src.innerHTML;
    var wrap=document.querySelector('cart-drawer');
    if(wrap){ wrap.classList.toggle('is-empty', !cart || cart.item_count===0); }
    rebindDrawer();
    log('drawer prekreslen, polozek:', cart?cart.item_count:'?');
    return true;
  }).catch(function(e){ log('DRAWER SELHAL:', e.message||e); return false; });
}
function redrawCartPage(pokus){
  var liveItems=document.querySelector('cart-items');
  if(!liveItems){ return Promise.resolve(false); }
  var od=Date.now();
  return fetchSection('main-cart-items').then(function(doc){
    if(zastarale(od) && (pokus||0)<2){ log('stranka kosiku je stara, beru cerstvou'); return redrawCartPage((pokus||0)+1); }
    var src=doc.querySelector('cart-items');
    if(!src){ throw new Error('v odpovedi neni cart-items'); }
    selfMutating=true;
    liveItems.innerHTML=src.innerHTML;
    liveItems.classList.toggle('is-empty', !cart || cart.item_count===0);
    paintTotals();
    log('stranka kosiku prekreslena (footer zamerne ponechan)');
    return true;
  }).catch(function(e){ log('STRANKA KOSIKU SELHALA:', e.message||e); return false; });
}
function redrawBubble(){
  var dst=document.querySelector('#cart-icon-bubble');
  if(!dst){ return Promise.resolve(false); }
  return fetchSection('cart-icon-bubble').then(function(doc){
    var src=doc.querySelector('.shopify-section') || doc.body;
    if(src){ selfMutating=true; dst.innerHTML=src.innerHTML; }
    return true;
  }).catch(function(e){ log('ikonka selhala:', e.message||e); return false; });
}
function redrawAll(){
  return Promise.all([redrawDrawer(), redrawCartPage(), redrawBubble()])
    .then(function(res){
      setTimeout(function(){ selfMutating=false; },250);
      return res[0];
    });
}
function rebindDrawer(){
  var d=document.querySelector('cart-drawer');
  if(!d){ return; }
  var ov=d.querySelector('#CartDrawer-Overlay');
  if(ov&&!ov.__nyriBound){
    ov.__nyriBound=1;
    ov.addEventListener('click',function(){ if(typeof d.close==='function'){ d.close(); } });
  }
}
function openDrawer(){
  var d=document.querySelector('cart-drawer');
  if(!d||typeof d.open!=='function'){ log('drawer neexistuje'); return false; }
  if(!cart||cart.item_count===0){ log('kosik prazdny, neotviram'); return false; }
  try{ d.open(); log('drawer otevren'); return true; }
  catch(e){ log('drawer.open selhal:', e.message||e); return false; }
}


function post(url,body){
  return fetch(url,{method:'POST',cache:'no-store',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(body)})
    .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); });
}
function mutate(url, body, delayMs){
  return post(url,body)
    .then(function(){ return delayMs ? new Promise(function(res){ setTimeout(res,delayMs); }) : null; })
    .then(function(){ return getCart(); })
    .then(function(c){ cart=c; return redrawAll(); })
    .then(function(ok){ afterCart(); return ok; });
}


function markFeeRows(){
  document.querySelectorAll('.cart-item').forEach(function(row){
    if(row.querySelector('a[href*="'+FEE_HANDLE+'"]')){ row.classList.add('nyri-fee-row'); }
  });
}


function money(c){
  var s=(c/100).toFixed(2).replace('.',',').split(',');
  s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,' ');
  return s.join(',')+' Kč';
}
function animate(from,to){
  var els=[].slice.call(document.querySelectorAll('.totals__total-value'));
  if(!els.length){ return; }
  var start=null;
  els.forEach(function(e){ e.classList.add('nyri-cod__pulse'); });
  function step(ts){
    if(start===null){ start=ts; }
    var p=Math.min((ts-start)/650,1);
    var e=1-Math.pow(1-p,3);
    els.forEach(function(el){ el.textContent=money(from+(to-from)*e); });
    if(p<1){ requestAnimationFrame(step); }
  }
  requestAnimationFrame(step);
}


function cardInner(state){
  if(state==='sub'){
    return '<p class="nyri-cod__h">'+T.subHeading+'</p><p class="nyri-cod__p">'+T.subText+'</p>';
  }
  if(state==='on'){
    return '<p class="nyri-cod__h"><span class="nyri-cod__tick">&#10003;</span>'+T.onHeading+'</p>'
      +'<p class="nyri-cod__p">'+T.onText+'</p>'
      +'<button type="button" class="nyri-cod__cancel" data-nyri-act="off">'+T.onCancel+'</button>'
      +'<p class="nyri-cod__err">'+T.codErr+'</p>';
  }
  return '<p class="nyri-cod__h">'+T.offHeading+'</p>'
    +'<p class="nyri-cod__p">'+T.offText+'</p>'
    +'<button type="button" class="nyri-cod__btn" data-nyri-act="on">'
    +  '<span>'+T.offButton+'</span><span class="nyri-cod__tag">'+T.feeLabel+'</span></button>'
    +'<p class="nyri-cod__err">'+T.codErr+'</p>';
}
function paintCards(){
  var sub=hasSub(), on=feeQty()>0;
  document.body.classList.toggle('nyri-cod-on', on && !sub);
  var show=realCount()>0;
  var want=sub?'sub':(on?'on':'off');
  document.querySelectorAll('.cart__ctas').forEach(function(ctas){
    var parent=ctas.parentNode;
    if(!parent){ return; }
    var card=parent.querySelector(':scope > [data-nyri-cod]');
    if(!show){ if(card){ card.remove(); } return; }
    if(!card){
      card=document.createElement('div');
      card.setAttribute('data-nyri-cod','1');
      parent.insertBefore(card,ctas);
    }
    if(card.getAttribute('data-state')!==want){
      card.setAttribute('data-state',want);
      card.className='nyri-cod'+(want==='on'?' is-on':'')+(want==='sub'?' is-info':'');
      card.innerHTML=cardInner(want);
    }
  });
}
function setCardBusy(b){
  document.querySelectorAll('[data-nyri-cod]').forEach(function(c){
    c.classList.toggle('is-busy',b);
    if(b){ c.classList.remove('has-err'); }
  });
}
function showCardErr(){
  document.querySelectorAll('[data-nyri-cod]').forEach(function(c){ c.classList.add('has-err'); });
}
function setFee(want){
  if(busy){ return; }
  if(want && hasSub()){ return; }
  if(want === (feeQty()>0)){ return; }
  busy=true; setCardBusy(true);
  var from=cart?cart.total_price:0;
  animate(from, want?from+FEE_CENTS:from-FEE_CENTS);
  log(want?'pridavam dobirku':'rusim dobirku');
  var p = want
    ? (feeQty()>0 ? mutate(root()+'cart/change.js',{id:String(FEE_VARIANT),quantity:1},650)
                  : mutate(root()+'cart/add.js',{items:[{id:FEE_VARIANT,quantity:1}]},650))
    : mutate(root()+'cart/change.js',{id:String(FEE_VARIANT),quantity:0},650);
  p.then(function(){ busy=false; setCardBusy(false); })
   .catch(function(e){
      log('DOBIRKA SELHALA:', (e&&e.message)||JSON.stringify(e));
      busy=false; setCardBusy(false); showCardErr();
      getCart().then(function(c){ cart=c; afterCart(); }).catch(function(){});
    });
}


function afterCart(){
  markFeeRows();
  paintCards();
  if(!busy && !autoFixing && feeQty()>0 && (realCount()===0 || hasSub())){
    autoFixing=true;
    log('odstranuju poplatek automaticky');
    mutate(root()+'cart/change.js',{id:String(FEE_VARIANT),quantity:0})
      .then(function(){ autoFixing=false; })
      .catch(function(){ autoFixing=false; });
  }
}


document.addEventListener('click',function(ev){
  var b=ev.target.closest('[data-nyri-act]');
  if(!b){ return; }
  ev.preventDefault();
  setFee(b.getAttribute('data-nyri-act')==='on');
});


var pageHandle=null, pair=[];
var mm=window.location.pathname.match(/\/products\/([^/?#]+)/);
if(mm){ pageHandle=mm[1]; }
if(pageHandle && pageHandle!==FEE_HANDLE){
  pair=(OVERRIDE[pageHandle]||DEFAULT_PAIR).filter(function(p){ return p.handle!==pageHandle; });
}
function upMoney(c){ return (c/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,' ')+' Kč'; }
function loadProduct(p){
  return fetch('/products/'+p.handle+'.js',{headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(d){
      var v=null;
      (d.variants||[]).forEach(function(x){ if(x.id===p.variant){ v=x; } });
      if(!v||!v.available){ return null; }
      return {id:p.variant,title:d.title,price:v.price,img:d.featured_image};
    })
    .catch(function(){ return null; });
}
function buildUpsell(items,form){
  if(document.querySelector('[data-nyri-up]')){ return; }
  var wrap=document.createElement('div');
  wrap.className='nyri-up-wrap'; wrap.setAttribute('data-nyri-up','1');
  var h=document.createElement('p'); h.className='nyri-up__h'; h.textContent=T.upHeading;
  wrap.appendChild(h);
  var box=document.createElement('div'); box.className='nyri-up';
  items.forEach(function(it){
    var row=document.createElement('div');
    row.className='nyri-up__i';
    row.setAttribute('data-up-id',it.id);
    row.innerHTML='<span class="nyri-up__box">&#10003;</span>'
      +'<img class="nyri-up__img" src="'+(it.img||'')+'" alt="">'
      +'<span class="nyri-up__t">'+it.title+'</span>'
      +'<span class="nyri-up__p">'+upMoney(it.price)+'</span>';
    box.appendChild(row);
  });
  wrap.appendChild(box);
  var btn=form.querySelector('button[type="submit"], input[type="submit"]');
  if(btn&&btn.parentNode){ btn.parentNode.insertBefore(wrap,btn); } else { form.appendChild(wrap); }
  log('upsell vlozen:',items.length);
}
document.addEventListener('click',function(ev){
  var row=ev.target.closest('.nyri-up__i');
  if(!row){ return; }
  row.classList.toggle('on');
});
function isAddForm(el){
  if(!el||el.tagName!=='FORM'){ return false; }
  return el.id==='nyri-form' || (el.getAttribute('action')||'').indexOf('/cart/add')>-1;
}
function upErr(form,show){
  var e=form.querySelector('.nyri-up-err');
  if(!show){ if(e){ e.remove(); } return; }
  if(!e){ e=document.createElement('p'); e.className='nyri-up-err'; form.appendChild(e); }
  e.textContent=T.upErr;
}
document.addEventListener('submit',function(ev){
  var form=ev.target;
  if(!isAddForm(form)){ return; }
  ev.preventDefault();
  if(busy){ return; }
  upErr(form,false);
  var idEl=document.getElementById('nyri-variant-id')||form.querySelector('[name="id"]');
  if(!idEl||!idEl.value){ log('nenasel jsem variantu'); upErr(form,true); return; }
  var qEl=form.querySelector('[name="quantity"]');
  var items=[{id:parseInt(idEl.value,10), quantity:(qEl?parseInt(qEl.value,10)||1:1)}];
  document.querySelectorAll('.nyri-up__i.on').forEach(function(r){
    items.push({id:parseInt(r.getAttribute('data-up-id'),10), quantity:1});
  });
  var btn=form.querySelector('button[type="submit"]');
  var label=btn?btn.textContent:null;
  if(btn){ btn.textContent=T.upAdding; btn.disabled=true; }
  busy=true;
  log('pridavam do kosiku:', items.length, 'polozek');
  /* RYCHLE: košík vyjede hned a jeden produkt se uloží i vykreslí jedním dotazem */
  var drawer=document.querySelector('cart-drawer');
  var rychle=!!(drawer && drawer.open && drawer.renderContents && drawer.getSectionsToRender);
  if(rychle){ drawer.classList.add('nyri-nacita'); try{ drawer.open(btn); }catch(e){} }
  var pridani = (rychle && items.length===1)
    ? post(root()+'cart/add.js',{id:items[0].id, quantity:items[0].quantity,
        sections:drawer.getSectionsToRender().map(function(x){ return x.id; }), sections_url:location.pathname})
        .then(function(r){
          if(!r.sections){ return getCart().then(function(c){ cart=c; return redrawAll(); }).then(function(ok){ afterCart(); return ok; }); }
          selfMutating=true;
          drawer.classList.remove('is-empty');
          drawer.renderContents(r);
          rebindDrawer();
          setTimeout(function(){ selfMutating=false; },250);
          getCart().then(function(c){ cart=c; afterCart(); }).catch(function(){});
          return true;
        })
    : mutate(root()+'cart/add.js',{items:items});
  pridani
    .then(function(drawerOk){
      if(drawer){ drawer.classList.remove('nyri-nacita'); }
      if(btn){ btn.textContent=label; btn.disabled=false; }
      document.querySelectorAll('.nyri-up__i.on').forEach(function(r){ r.classList.remove('on'); });
      busy=false;
      if(drawerOk){ openDrawer(); }
      else { log('drawer se neprekreslil -> jdu na /cart'); window.location.href=cartUrl(); }
    })
    .catch(function(e){
      log('PRIDANI SELHALO:', (e&&e.message)||JSON.stringify(e));
      if(drawer){ drawer.classList.remove('nyri-nacita'); if(rychle && drawer.close){ drawer.close(); } }
      busy=false;
      if(btn){ btn.textContent=label; btn.disabled=false; }
      upErr(form,true);
    });
});


var obsTimer=null;
function watch(){
  var mo=new MutationObserver(function(muts){
    if(selfMutating||busy||autoFixing){ return; }
    var relevant=false;
    for(var i=0;i<muts.length;i++){ if(!isForeign(muts[i].target)){ relevant=true; break; } }
    if(!relevant){ return; }
    clearTimeout(obsTimer);
    obsTimer=setTimeout(function(){
      getCart().then(function(c){ cart=c; afterCart(); }).catch(function(){});
    },300);
  });
  
  ['cart-drawer','cart-items'].forEach(function(sel){
    var el=document.querySelector(sel);
    if(el){ mo.observe(el,{childList:true,subtree:true}); }
  });
}


function boot(){
  dbgInit();
  log('start, stranka:', window.location.pathname);
  rebindDrawer();
  getCart().then(function(c){
    cart=c;
    log('kosik nacten, polozek:', c.item_count);
    afterCart();
    watch();
  }).catch(function(e){ log('KOSIK SE NENACETL:', e.message||e); });
  if(pair.length){
    var form=document.getElementById('nyri-form')||document.querySelector('form[action*="/cart/add"]');
    if(form){
      Promise.all(pair.map(loadProduct)).then(function(res){
        var items=res.filter(Boolean);
        if(items.length){ buildUpsell(items,form); }
      });
    } else { log('formular pridani nenalezen'); }
  }
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); }
else{ boot(); }
})();

/* Výdejní místo: po zavření mapy Globe vrátit stránku tam, kde zákaznice byla */
(function(){
  var ulozeno = null;
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.globe-delivery-selector-container')) { ulozeno = window.scrollY; }
  }, true);
  new MutationObserver(function(){
    if (ulozeno === null) { return; }
    if (getComputedStyle(document.body).position === 'fixed') { return; }
    var y = ulozeno; ulozeno = null;
    setTimeout(function(){ window.scrollTo(0, y); }, 60);
  }).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
})();